// @ts-nocheck
import { Component } from "@theme/component";
import { debounce, isDesktopBreakpoint } from "@theme/utilities";
const ACTIVATE_DELAY_MOBILE = 500;
/**
 *
 * @typedef {object} Refs
 *  * @property {HTMLElement[]} [listbutton] - buttons in first column.

 */
export class DDMProductMenu extends Component {
  requiredRefs = [];
  #observer = null;

  connectedCallback() {
    super.connectedCallback();
    this.#initFirstButton();
    this.#observeSubmenuActive();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  #initFirstButton() {
    if (!isDesktopBreakpoint()) return;
    requestAnimationFrame(() => {
      const buttons = this.refs.listbutton;
      const hasActive = buttons?.some(
        (btn) => btn.getAttribute("aria-expanded") === "true",
      );
      if (buttons?.length > 0 && !hasActive) {
        buttons[0].setAttribute("aria-expanded", "true");
      }
    });
  }

  #observeSubmenuActive() {
    const submenu = this.closest('[ref="submenu[]"]');
    if (!submenu) return;

    this.#observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-active" &&
          submenu.hasAttribute("data-active")
        ) {
          this.#initFirstButton();
        }
      }
    });

    this.#observer.observe(submenu, { attributes: true });
  }

  #getPanelContent(button) {
    return button?.nextElementSibling?.querySelector(
      ".ddm-cards-panel__content",
    );
  }

  activate(event) {
    if (isDesktopBreakpoint()) {
      this.#debouncedActivateHandler.cancel();
      this.#activateHandler(event);
    } else {
      this.#debouncedActivateHandler(event);
    }
  }

  #activateHandler = (event) => {
    const button = event.target;
    const buttons = this.refs.listbutton;
    const newIndex = buttons.indexOf(button);
    const currentIndex = buttons.findIndex(
      (btn) => btn.getAttribute("aria-expanded") === "true",
    );

    if (newIndex === currentIndex) return;

    if (window.innerWidth > 1024) {
      const direction = currentIndex === -1 || newIndex > currentIndex ? 1 : -1;
      const incomingContent = this.#getPanelContent(button);
      const outgoingContent =
        currentIndex >= 0 ? this.#getPanelContent(buttons[currentIndex]) : null;

      // Set incoming start position (no transition), then force reflow
      if (incomingContent) {
        incomingContent.style.transition = "none";
        incomingContent.style.transform = `translateY(${direction * 100}%)`;
        incomingContent.getBoundingClientRect(); // force reflow
        incomingContent.style.transition = "";
      }

      // aria-expanded drives opacity via CSS; transform drives position
      buttons.forEach((btn, i) =>
        btn.setAttribute("aria-expanded", i === newIndex ? "true" : "false"),
      );

      if (incomingContent) incomingContent.style.transform = "translateY(0)";
      if (outgoingContent)
        outgoingContent.style.transform = `translateY(${-direction * 100}%)`;
    } else {
      buttons.forEach((btn, i) =>
        btn.setAttribute("aria-expanded", i === newIndex ? "true" : "false"),
      );
    }
  };

  #debouncedActivateHandler = debounce(
    this.#activateHandler,
    ACTIVATE_DELAY_MOBILE,
  );

  deactivate() {
    const buttons = this.refs.listbutton;
    buttons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });
  }
}

if (!customElements.get("ddm-product-menu")) {
  customElements.define("ddm-product-menu", DDMProductMenu);
}
